function getAddToCartBtn() {
  return document.querySelector('[name="add"]');
}

function getShopPayBtn() {
  return document.querySelector('.shopify-payment-button__button');
}

function handleVariantChange(variantId) {
  const container = document.getElementById('rlv-badge-container');
  if (container) container.innerHTML = '';

  const el = document.querySelector(`.rlv-variant-data[data-variant-id="${variantId}"]`);
  const addToCartBtn = getAddToCartBtn();
  const shopPayBtn = getShopPayBtn();

  if (!el) {
    // Not a controlled variant — leave buttons in whatever state Shopify set them
    return;
  }

  const isWholesale = el.dataset.isWholesale === 'true';
  const isRetailOnly = el.dataset.retailOnly === 'true';
  const isWholesaleExcluded = el.dataset.wholesaleExcluded === 'true';

  if (isRetailOnly && !isWholesale) {
    // 3-Pack Mini-Bales: regular customer — always sold out
    if (addToCartBtn) addToCartBtn.disabled = true;
    if (shopPayBtn) shopPayBtn.disabled = true;
    if (container) {
      container.innerHTML = '<span class="variant-badge variant-badge--location">Available exclusively at Critter Jungle Orleans!';
    }

  } else if (isWholesaleExcluded && isWholesale) {
    // 15 lb Bundle: wholesale customer — not available to them
    setTimeout(() => {
      const addToCartBtn = getAddToCartBtn();
      const shopPayBtn = getShopPayBtn();
      if (addToCartBtn) addToCartBtn.disabled = true;
      if (shopPayBtn) shopPayBtn.disabled = true;
    }, 5);
    if (container) {
      container.innerHTML = '<span class="variant-badge variant-badge--wholesale-excluded">15 lb Bundles are available for direct sale customers only</span>';
    }

  } else {
    // All other cases (Mini Bale for anyone, 3-Pack for wholesale, 15 lb for retail) — enable buttons
    if (addToCartBtn) addToCartBtn.disabled = false;
    if (shopPayBtn) shopPayBtn.disabled = false;
  }
}

function getSelectedVariantId() {
  const select = document.querySelector('select[name="id"]');
  if (select) return select.value;
  const input = document.querySelector('input[name="id"]');
  if (input) return input.value;
  return null;
}

function initRetailLocationVariants() {
  if (!document.querySelector('.rlv-variant-data')) return;

  // Handle the variant that's selected on page load
  const initialVariantId = getSelectedVariantId();
  if (initialVariantId) handleVariantChange(initialVariantId);

  // Listen for Shopify variant changes (theme event)
  document.addEventListener('variant:changed', (e) => {
    const variantId = e?.detail?.variant?.id?.toString()
      || e?.detail?.id?.toString();
    if (variantId) handleVariantChange(variantId);
  });

    // Fallback: watch the hidden input directly (Dawn theme)
  const variantInput = document.querySelector('input[name="id"], select[name="id"]');
  if (variantInput) {
    variantInput.addEventListener('change', () => {
      handleVariantChange(variantInput.value);
    });
  }

  // Replace Sale badge text for wholesale customers
  const isWholesalePage = document.querySelector('.rlv-variant-data[data-is-wholesale="true"]');
  if (isWholesalePage) {
    document.querySelectorAll('.price__badge-sale').forEach(badge => {
      badge.textContent = 'Wholesale Pricing';
    });
  }
}

document.addEventListener('DOMContentLoaded', initRetailLocationVariants);
